import { HorizontalMarkSizeEnum, HorizontalMarkSizeEnumsObj } from "../enums/HorizontalMarkSizeEnum"
import { SrciButtonSizeEnum, SrciButtonSizeEnumsObj } from "../enums/SrciButtonSizeEnum"
import { PaymentMethodEnum, PaymentMethodEnumsObj } from "../enums/PaymentMethodEnum"

const validate = (enumsObj: any, value: any) => Object.values(enumsObj).includes(value)

export const validatePaymentMethodEnum = (paymentMethodEnum: PaymentMethodEnum) =>
  validate(PaymentMethodEnumsObj, paymentMethodEnum)

export const validateButtonSizeEnum = (srciButtonSizeEnum: SrciButtonSizeEnum) =>
  validate(SrciButtonSizeEnumsObj, srciButtonSizeEnum)

export const validateHorizontalMarkSizeEnum = (horizontalMarkSizeEnum: HorizontalMarkSizeEnum) =>
  validate(HorizontalMarkSizeEnumsObj, horizontalMarkSizeEnum)
